import { useTranslation } from 'react-i18next';
import * as Styled from './SuggestedTag.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SuggestedTag = () => {
  const {
    t
  } = useTranslation('blocks.donation');
  return /*#__PURE__*/_jsxs(Styled.SuggestedTag, {
    children: [/*#__PURE__*/_jsx(Styled.StyledHeart, {
      "aria-hidden": true,
      focusable: "false"
    }), /*#__PURE__*/_jsx("span", {
      children: t('AmountButton.suggested', 'Suggested')
    })]
  });
};